import { toast } from "react-toastify";
import { API_NOTIFICACIONES } from "../../views/MainLayout/components/shared/services/notificaciones";
import { setErrorMessage } from "../../views/MainLayout/components/shared/helpers/functionalities";

const initialState = [];

export const recordatoriosClientesReducer = (state = initialState, action) => {
    switch(action.type){
        case "recordatorios/fullfilled": {
            return action.payload;
        }
        default:
            return state
    }
}

export const fetchRecordatoriosClientes = () => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await API_NOTIFICACIONES.getRecordatorios()
        const data = await response.data;
        dispatch({ type: 'recordatorios/fullfilled', payload: data })
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}